import { render, staticRenderFns } from "./MunicipalitySelect.vue?vue&type=template&id=43d0d038&"
import script from "./MunicipalitySelect.vue?vue&type=script&lang=ts&"
export * from "./MunicipalitySelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports